import { browserStorage, defineStorageEntry, stringStorageCodec } from "@/lib/browserStorage";

const accessTokenEntry = defineStorageEntry({
  area: "session",
  key: "immi_access_token",
  codec: stringStorageCodec,
});

export const getAccessToken = (): string | null => browserStorage.get(accessTokenEntry);

export const setAccessToken = (accessToken: string): boolean => browserStorage.set(accessTokenEntry, accessToken);

export const clearAccessToken = (): boolean => browserStorage.remove(accessTokenEntry);
